import { gql } from '@apollo/client';

export const GET_SURROUNDING_INFORMATION_CATEGORY_WITH_ALL_LOCALES = gql`
  fragment CommonSurroundingInformationCategory on SurroundingInformationCategory {
    id
    title
    locale
    appSortOrder
    hidden
  }

  fragment CommonSurroundingInformationPropertyForCategory on SurroundingInformationProperty {
    id
    icon
    text
    badgeColor
    appSortOrder
    locale
  }

  fragment CommonSurroundingInformationForCategory on SurroundingInformation {
    id
    title
    appSortOrder
    bodyText
    externalBannerImage
    bannerImage {
      id
      formats
      url
    }
    locale
    locationName
    shortDescription
    openingTimes
    hidden
    properties {
      ...CommonSurroundingInformationPropertyForCategory
      localizations {
        ...CommonSurroundingInformationPropertyForCategory
      }
    }
  }

  query GetSurroundingInformationCategoryWithAllLocales($id: ID!) {
    surroundingInformationCategory(id: $id) {
      ...CommonSurroundingInformationCategory
      localizations {
        ...CommonSurroundingInformationCategory
      }
      surroundingInformations {
        ...CommonSurroundingInformationForCategory
        localizations {
          ...CommonSurroundingInformationForCategory
        }
      }
    }
  }
`;
